// src/components/Toast.js
import React, { useState, useEffect } from 'react';

const Toast = ({ message, show, onHide }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (show) {
            setVisible(true);
            const timer = setTimeout(() => {
                setVisible(false);
                setTimeout(() => onHide(), 300);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [show, onHide]);

    return (
        <div
            className="toastify"
            style={{
                right: visible ? '4px' : '-200px',
                opacity: visible ? 1 : 0
            }}
        >
            <div className="icon">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon icon-tabler icon-tabler-circle-check"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#00b341"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                    <path d="M9 12l2 2l4 -4" />
                </svg>
            </div>
            <div className="msg">{message || "Item Added"}</div>
        </div>
    );
};

export default Toast;